import React from 'react';
import JournalThumbHtmlView from './JournalHtml';
import JournalThumbReactView from './Journal';
const JournalThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(JournalThumbHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(JournalThumbReactView, props);
};
JournalThumbView.displayName = 'JournalThumbView';
export default JournalThumbView;
